// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Toggle_toggle__VaPzN","slider":"Toggle_slider__1j8GF","on":"Toggle_on__1Q9Kg Toggle_toggle__VaPzN","off":"Toggle_off__1rcUC Toggle_toggle__VaPzN"};